import styled from "styled-components";
import Price from "../../../../@ui/Price";

interface ItemTotalsProps {
  transactionCurrencyCode: string;
  totalExTax: number;
  totalTax: number;
  totalIncTax: number;
}

const TotalsGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 5fr 1fr;
  width: 100%;
  gap: 20px;
  padding: 0.5rem 0.2rem;
  &:not(:last-child) {
    border-bottom: 1px solid #ccc; /* Adjust color and style as needed */
  }
`;

const TotalItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TotalPrice = styled(TotalItem)`
  grid-column: 3;
  text-align: right;
`;

const ItemTotals = ({
  transactionCurrencyCode,
  totalExTax,
  totalTax,
  totalIncTax,
}: ItemTotalsProps) => {
  return (
    <>
      <TotalsGrid>
        <TotalItem>
          <span>Subtotal</span>
        </TotalItem>
        <TotalPrice>
          <Price currencyCode={transactionCurrencyCode} price={totalExTax} />
        </TotalPrice>
      </TotalsGrid>
      <TotalsGrid>
        <TotalItem>Tax</TotalItem>
        <TotalPrice>
          <Price currencyCode={transactionCurrencyCode} price={totalTax} />
        </TotalPrice>
      </TotalsGrid>
      <TotalsGrid>
        <TotalItem>Total</TotalItem>
        <TotalPrice>
          <Price currencyCode={transactionCurrencyCode} price={totalIncTax} />
        </TotalPrice>
      </TotalsGrid>
    </>
  );
};

export default ItemTotals;
